import { render } from 'preact';
import type { DropClient } from './core/contract';
import { uploadDrop, downloadDrop, fetchDropMeta, previewDrop } from './core/drop-service';
import { App } from './ui/App';
import { createDropClient } from './core';
import './styles/main.css';
declare global {
  interface Window {
    __drop?: DropClient;
    __dropService?: {
      previewDrop: typeof previewDrop;
      uploadDrop: typeof uploadDrop;
      downloadDrop: typeof downloadDrop;
      fetchDropMeta: typeof fetchDropMeta;
    };
  }
}
async function start() {
  const params = new URLSearchParams(location.search);
  const initialHash = location.hash;
  if (/^#(?:pair|room)=/.test(initialHash)) {
    history.replaceState(null, '', `${location.pathname}${location.search}`);
  }
  const client =
    params.get('mock') === '1'
      ? (await import('./core/mock')).createMockClient()
      : createDropClient();
  window.__drop = client;
  window.__dropService = { uploadDrop, downloadDrop, fetchDropMeta, previewDrop };
  const files: File[] = [];
  if (params.has('share') && 'caches' in window) {
    try {
      const cache = await caches.open('drop-shares-v1');
      const prefix = `/__shared/${encodeURIComponent(params.get('share') || '')}/`;
      const keys = (await cache.keys()).filter((k) => new URL(k.url).pathname.startsWith(prefix));
      for (const key of keys) {
        const response = await cache.match(key);
        if (!response) continue;
        const blob = await response.blob();
        const headerName = response.headers.get('X-File-Name') || 'Shared file';
        files.push(
          new File([blob], decodeURIComponent(headerName), {
            type: response.headers.get('Content-Type') || blob.type,
          }),
        );
        await cache.delete(key);
      }
    } catch (e) {
      console.warn('Shared files could not be recovered', e);
    }
    params.delete('share');
    const paramStr = params.size ? `?${params}` : '';
    history.replaceState(null, '', `${location.pathname}${paramStr}${location.hash}`);
  }
  render(
    <App client={client} sharedFiles={files} initialHash={initialHash} />,
    document.getElementById('app')!,
  );
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    void navigator.serviceWorker
      .register('/sw.js')
      .catch((e) => console.warn('Offline support unavailable', e));
  }
}
void start().catch(() => {
  render(
    <div class="startup-error">
      <h1>Let’s try that again.</h1>
      <p>Drop couldn’t open just yet.</p>
      <button class="button primary" onClick={() => location.reload()}>
        Try again
      </button>
    </div>,
    document.getElementById('app')!,
  );
});
